import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "custom-project-templates"
    }}>{`Custom project templates`}</h1>
    <p>{`The PWA Studio `}<a parentName="p" {...{
        "href": "/commerce/pwa-studio/guides/packages/buildpack/scaffolding/"
      }}>{`scaffolding tool`}</a>{` uses the `}<inlineCode parentName="p">{`venia-concept`}</inlineCode>{` package as the default template for new storefront projects, but
you can use your own custom project template if it contains the necessary instructions.`}</p>
    <h2 {...{
      "id": "buildpack-folder"
    }}>{`Buildpack folder`}</h2>
    <p>{`The presence of a `}<inlineCode parentName="p">{`create.js`}</inlineCode>{` file inside a `}<inlineCode parentName="p">{`_buildpack`}</inlineCode>{` directory indicates that a project can be used as a template for the scaffolding command.
You can see an example of this directory in the `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/tree/develop/packages/venia-concept/_buildpack"
      }}><inlineCode parentName="a">{`venia-concept`}</inlineCode>{` package`}</a>{`.`}</p>
    <h3 {...{
      "id": "the-createjs-file"
    }}>{`The `}<inlineCode parentName="h3">{`create.js`}</inlineCode>{` file`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`create.js`}</inlineCode>{` file defines a function that returns an object with `}<inlineCode parentName="p">{`ignores`}</inlineCode>{`, `}<inlineCode parentName="p">{`before`}</inlineCode>{`, `}<inlineCode parentName="p">{`visitor`}</inlineCode>{`, and `}<inlineCode parentName="p">{`after`}</inlineCode>{` properties.
These properties are functions that provide instructions for the buildpack `}<inlineCode parentName="p">{`create-project`}</inlineCode>{` command.`}</p>
    <p>{`The function defined in `}<inlineCode parentName="p">{`create.js`}</inlineCode>{` is passed in an object with the following properties:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`fs`}</inlineCode>{` - An instance of the `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/fs-extra"
        }}><inlineCode parentName="a">{`fs-extra`}</inlineCode>{` library`}</a>{`, which provides utilities for most of the common copy operations.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`tasks`}</inlineCode>{` - An object which provides common handlers that template developers can use for globs.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`options`}</inlineCode>{` - An object that contains the parameters used in the `}<inlineCode parentName="li">{`buildpack create-project`}</inlineCode>{` command.`}</li>
    </ul>
    <p>{`When the create project command executes, it walks the template project's directory tree and applies the instructions provided by the returned object's properties.`}</p>
    <h4 {...{
      "id": "ignores"
    }}><inlineCode parentName="h4">{`ignores`}</inlineCode></h4>
    <p>{`The `}<inlineCode parentName="p">{`ignores`}</inlineCode>{` property is an array of `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Glob_(programming)"
      }}>{`glob patterns`}</a>{`.
Files that match these patterns are not processed by the create project command.`}</p>
    <p>{`Use this property to prevent the create command from processing project-specific or unimportant files.`}</p>
    <h3 {...{
      "id": "before"
    }}><inlineCode parentName="h3">{`before`}</inlineCode></h3>
    <p>{`The `}<inlineCode parentName="p">{`before`}</inlineCode>{` property defines a function that runs before the command walks the directory tree.
Use this property to add pre-processing logic during project creation.`}</p>
    <h3 {...{
      "id": "visitor"
    }}><inlineCode parentName="h3">{`visitor`}</inlineCode></h3>
    <p>{`The `}<inlineCode parentName="p">{`visitor`}</inlineCode>{` property is a mapping object that maps a glob pattern to a file handler function.
The glob pattern is the map key, and the file handler function is the value associated with that key.`}</p>
    <p>{`When the project creation tool walks the directory tree, it looks for files that match each glob pattern and runs the visitor function associated with that pattern.`}</p>
    <p>{`Use this property to perform custom transformation logic on a file before copying it to the new project.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`{
  visitor: {
    'package.json': ({ path, targetPath, options }) => {
      const pkg = fs.readJsonSync(path);
      pkg.name = options.name;
      fs.writeJsonSync(targetPath, JSON.stringify(pkg, null, 4));
    }
  }
}
`}</code></pre>
    <p>{`This is an example of a visitor property that targets the template project's `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file and modifies its name before writing it out to the `}<inlineCode parentName="p">{`targetPath`}</inlineCode>{`.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`The `}<inlineCode parentName="p">{`buildpack create-project`}</inlineCode>{` command does not perform the actual file copy.
Use the convenient `}<inlineCode parentName="p">{`tasks.IGNORE`}</inlineCode>{` and `}<inlineCode parentName="p">{`tasks.COPY`}</inlineCode>{` handlers provided by the tool to perform common ignore and copy file tasks.`}</p>
    <h3 {...{
      "id": "after"
    }}><inlineCode parentName="h3">{`after`}</inlineCode></h3>
    <p>{`The `}<inlineCode parentName="p">{`after`}</inlineCode>{` property defines a function that runs after the command walks the directory tree.
Use this property to add post-processing logic during project creation.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      